{
    "name": "pathingjs",
    "version": "1.0.0",
    "main": "dist/pathing.min.js",
    "module": "dist/pathing.esm.js",
    "exports": {
        ".": {
            "import": {
                "types": "./dist/types/index.d.ts",
                "default": "./dist/pathing.esm.js"
            },
            "require": {
                "types": "./dist/types/index.d.ts",
                "default": "./dist/pathing.min.js"
            }
        }
    },
    "types": "dist/types/index.d.ts",
    "type": "module",
    "files": [
        "dist"
    ],
    "scripts": {
        "build": "node build.js && tsc --emitDeclarationOnly --outDir dist/types",
        "copy": "cp dist/pathing.{min,esm}.{js,js.map} ../public/ && cp dist/pathing.min.js ../public/pathing.js",
        "sdk": "npm run build && npm run copy",
        "push": "npm run sdk && npm version patch && npm publish",
        "sandbox": "node sandbox.js"
    },
    "description": "Enhanced analytics tracking library with comprehensive device, browser, and engagement data collection",
    "keywords": [
        "analytics",
        "tracking",
        "events",
        "device-detection",
        "performance-monitoring",
        "user-engagement"
    ],
    "devDependencies": {
        "esbuild": "^0.25.3",
        "express": "^5.1.0",
        "typescript": "^5.0.0"
    }
}
